/* eslint-disable no-console */
console.log(
  "%c Happy Birthday! ",
  "background-color:#93B7F3;color:white;padding:2px;"
);
console.log(
  "%c 虽然离死亡更进一步，但祝你新的一岁更加开心！",
  "background-color:dodgerblue;color:white;padding:2px;"
);
console.log(
  "%c From your friend. @YunYouJun %c https://github.com/YunYouJun/birthday ",
  "background-color:#000000;color:white;padding:3px;",
  "border: 1px solid black;padding:2px;"
);
